<template>
    <div class="wrapper">
        <div class="tit">
            <h1>Usuarios</h1>
        </div>
        <div class="ctn_general">
            <div class="tabla_ctn">
                <div class="tabla_filtros">
                    <div class="tfiltros_col xs right mOrder1 nowrap">
                        <div class="mdi mdi-magnify input_search mobileOrder3">
                            <form @submit.prevent="search">
                                <input type="search" placeholder="Buscar por nombres, apellidos o usuario"
                                       v-model="keyword">
                            </form>
                        </div>
                        <form action="" class="mobileOrder2">
                            <nuxt-link tag="a" class="btn" :to="{name:'user-creator'}">Agregar usuario
                            </nuxt-link>
                        </form>
                    </div>
                </div>

                <div class="tabla_scroll">
                    <table class="lProducto con_options">
                        <thead>
                        <tr>
                            <th>Correo</th>
                            <th>Nombre</th>
                            <th>Fecha de creación</th>
                            <th>Fecha de modificación</th>
                            <th class="d_option"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="u in users">
                            <td>{{ u.email }}</td>
                            <td>{{ u.name }}</td>
                            <td style="text-align: center;" v-date-local="u.createdAt"></td>
                            <td style="text-align: center;" v-date-local="u.updatedAt"></td>
                            <td class="d_option">
                                <i class="mdi mdi-dots-vertical"></i>
                                <span class="drop_options estados_pedido">
									<span @click="edit(u)">Editar</span>
                                    <span @click="remove(u)">Eliminar</span>
								</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <Paginator :total="total" :page="page" :page-size="pageSize" :pages="pages" :changePage="changePage"
                           :changePageSize="changePageSize"/>
            </div>
        </div>
    </div>
</template>
<script>

import Paginator from '../common/Paginator.vue'
import {loading} from '../../util/util'
import {paginatorMixin} from '../../util/paginatorMixin'
import Filters from '../common/Filters.vue'
import UserService from "../../services/UserService";
import alert from '../../util/alert'

export default {
    components: {
        Paginator,
        Filters
    },
    data() {
        return {
            users: [],
            selectedUser: null,
            keyword: null,
        }
    },
    mixins: [paginatorMixin],
    computed: {},
    methods: {
        changePage(p) {
            const self = this;
            self.page = p;
            self.listUsers(p, self.pageSize)
        },
        changePageSize(pageSize) {
            const self = this;
            this.page = 1;
            this.pageSize = pageSize;
            self.listUsers(1, pageSize)
        },
        async listUsers(page, pageSize) {
            loading(true);
            const self = this;
            const params = {page: page - 1, size: pageSize};
            if (self.keyword)
                params.keyword = self.keyword;

            const resp = (await UserService.list(params)).data.payload;
            self.users = resp.content;
            self.total = resp.totalElements;
            self.pages = resp.totalPages;
            loading(false);
        },
        search() {
            const self = this;
            self.page = 1;
            self.listUsers(self.page, self.pageSize);
        },
        edit(user) {
            this.$router.push({name: 'user-editor', params: {userId: user._id}});
        },
        remove(userIn) {
            const self = this;
            alert.dialog('¿Está seguro que desea eliminar al usuario?',
                null,
                async function () {
                    try {
                        loading(true);
                        await UserService.remove(userIn._id);
                        const index = self.users.indexOf(userIn);
                        self.users.splice(index, 1);
                        alert.success("Usuario eliminado correctamente.");
                    } catch (e) {
                        console.error(e);
                        alert.error("Error eliminando usuario")
                    } finally {
                        loading(false);
                    }
                });
        },
    },
    async mounted() {
        const self = this;
        self.listUsers();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/users/Users.vue